// Browser-only: remember what a logged-out visitor was entering, so after they
// sign up (including the email confirmation) or log in, they come straight
// back to it with their tickets ready. Kept for 24 hours on this device.

const KEY = 'rc_pending_entry';
const MAX_AGE = 24 * 3600 * 1000;

export function savePendingEntry(entry) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...entry, savedAt: Date.now() }));
  } catch {
    // Storage blocked: the visitor just starts again after logging in.
  }
}

export function loadPendingEntry() {
  try {
    const entry = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!entry || Date.now() - (entry.savedAt || 0) > MAX_AGE) return null;
    return entry;
  } catch {
    return null;
  }
}

export function clearPendingEntry() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Nothing to clear.
  }
}

/** Only same-site paths are allowed as a post-login destination. */
export function safeNext(next, fallback = '/user-dashboard') {
  if (typeof next !== 'string') return fallback;
  if (!next.startsWith('/') || next.startsWith('//') || next.startsWith('/\\')) return fallback;
  return next;
}
